import { Button } from "antd";
import { ArrowBigLeft } from "lucide-react";

const TopBar = ({ onBack }) => (
  <span className="bg-transparent backdrop-blur-md rounded-full">
    <Button
      type="text"
      className="flex items-center gap-2 font-medium !text-white text-sm sm:!text-lg hover:!text-violet-300 transition"
      icon={<ArrowBigLeft className="w-5 h-5 mt-2" />}
      onClick={onBack}
    >
      Back to Upload
    </Button>
  </span>
);

export default TopBar;